import React from 'react';

import {Wrapper, Link} from './Fraud.style';
import FraudNoticeContent from './FraudNoticeContent';

function FraudBody(props) {
  const {
    navToFraudAwareness,
    navToFraudWarning,
    navToSuppliersNotification,
  } = props;
  return (
    <Wrapper>
      <FraudNoticeContent />
      <Link onClick={navToFraudAwareness} style={{marginTop: '2rem'}}>
        Fraud Awareness - Helpful Advice
      </Link>
      <Link
        href={
          'https://jjwebcontent.blob.core.windows.net/pdfs/policies/JJ-Food-Service-Ltd-Supplying-Us-September-2020.pdf'
        }
      >
        JJ Food Service Limited - Supplying Us - T&amp;C
      </Link>
      <Link onClick={navToFraudWarning}>FWD Fraud Warning</Link>
      <Link
        href={
          'https://www.thegrocer.co.uk/companies/asda-berry-bros-iceland-and-jj-impersonated-by-fraudsters/232539.article'
        }
      >
        Asda, Berry, Bros, Iceland and JJ Impersonated by Fraudsters
      </Link>
      <Link onClick={navToSuppliersNotification}>
        Suppliers Notification - To Future and Existing Suppliers
      </Link>
    </Wrapper>
  );
}

export default FraudBody;
